export default {
  // any array should have unique values as the values are used as keys
  // months
  months: [
    'январь',
    'февраль',
    'март',
    'Апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'Сентябрь',
    'октябрь',
    'Ноябрь',
    'декабрь',
  ],
  months_calendar: {
    January: 'Январь',
    February: 'Февраль',
    March: 'Март',
    April: 'Апрель',
    May: 'Май',
    June: 'Июнь',
    July: 'Июль',
    August: 'Август',
    September: 'Сентябрь',
    October: 'Октябрь',
    November: 'Ноябрь',
    December: 'Декабрь',
  },
  // weekdays
  weekdays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  weekdays_booking_container: {
    Sunday: 'Воскресенье',
    Monday: 'Понедельник',
    Tuesday: 'Вторник',
    Wednesday: 'Среда',
    Thursday: 'Четверг',
    Friday: 'Пятница',
    Saturday: 'Суббота',
  },
  weekdays_calendar: {
    Sun: 'Вс',
    Mon: 'Пн',
    Tue: 'Вт',
    Wed: 'Ср',
    Thu: 'Чт',
    Fri: 'Пт',
    Sat: 'Сб',
  },
  // additional translations
  formatedShortMonths: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек',
  ],
  today: 'Сегодня',
  tomorrow: 'Завтра',
};
